<template>
  <span>
    [Empty: ADC {{ adcCount }}, MTJOY {{ mtJoyCount }},  PDC {{ pdcCount }}, SC2 {{ sc2Count }}, XPAC {{ xpacCount }}
    , DHRN {{ dhrnCount }}]
  </span>
</template>

<script>
export default {
  name: "EmptyTrailerDisplay",
  props: {
    trailers: Array,
  },
  data() {
    return {
      xpacLocations: ["525", "808", "824", "803", "801"],
    };
  },
  computed: {
    adcCount() {
      return this.trailers.filter(
        (t) =>
          t.status === "EMPTY" &&
          t.facilityLocation &&
          t.facilityLocation.facility === "ADC",
      ).length;
    },
    dhrnCount() {
      return this.trailers.filter(
        (t) => t.status === "EMPTY" && t.externalLocation === "DHRN",
      ).length;
    },
    mtJoyCount() {
      return this.trailers.filter(
        (t) =>
          t.status === "EMPTY" &&
          t.facilityLocation &&
          t.facilityLocation.facility === "MTJOY",
      ).length;
    },
    pdcCount() {
      return this.trailers.filter(
        (t) => t.status === "EMPTY" && t.externalLocation === "PDC",
      ).length;
    },
    sc2Count() {
      return this.trailers.filter(
        (t) => t.status === "EMPTY" && t.externalLocation === "SC2",
      ).length;
    },
    xpacCount() {
      return this.trailers.filter(
        (t) =>
          t.status === "EMPTY" &&
          t.externalLocation &&
          this.xpacLocations.indexOf(t.externalLocation) > -1,
      ).length;
    },
  },
};
</script>
